"use strict";

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SquareDrawer = void 0;

var SquareDrawer = /*#__PURE__*/function () {
  function SquareDrawer() {
    _classCallCheck(this, SquareDrawer);
  }

  _createClass(SquareDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 4;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.rect(-radius, -radius, radius * 2, radius * 2);
    }
  }]);

  return SquareDrawer;
}();

exports.SquareDrawer = SquareDrawer;